import { defineStore } from 'pinia'
import { ref } from 'vue'
import {login as loginApi,  getUserInfo as fetchUserInfo  } from '@/api/auth'
import type { UserInfo, LoginForm} from '@/types/user'
import { useCartStore } from './cart'

export const useUserStore = defineStore('user', () => {
  // 状态
  const token = ref(localStorage.getItem('token') || '')
  // 初始化时尝试恢复 userInfo
  const userInfo = ref<UserInfo | null>(null)
  const isLoggedIn = ref(!!token.value)

  const getUserInfo = async () => {
    try {
      const { data } = await fetchUserInfo()
      userInfo.value = data
      localStorage.setItem('userInfo', JSON.stringify(data))
      return data
    } catch (error) {
      userInfo.value = null
      localStorage.removeItem('userInfo')
      throw error
    }
  }
 
  const restoreUserInfo = () => {
    const infoStr = localStorage.getItem('userInfo')
    if (infoStr) {
      try {
        userInfo.value = JSON.parse(infoStr)
        isLoggedIn.value = !!token.value
      } catch {
        userInfo.value = null
      }
    }
  }
  // 初始化时自动恢复
  restoreUserInfo()



  // actions
  const login = async (loginForm: LoginForm) => {
    try {
      const { data } = await loginApi(loginForm)
      if(data === null) {
        return false
      }
      token.value = data.token
      localStorage.setItem('token', data.token)
      isLoggedIn.value = true
      // 登录后拉取用户信息并持久化
      const user = await getUserInfo()
      userInfo.value = user
      localStorage.setItem('userInfo', JSON.stringify(user))
      // 登录成功后自动初始化购物车
      const cartStore = useCartStore()
      await cartStore.loadCartFromServer()
      return true
    } catch (error) {
      token.value = ''
      localStorage.removeItem('token')
      userInfo.value = null
      isLoggedIn.value = false
      localStorage.removeItem('userInfo')
      throw error
    }
  }


  // 清除用户信息
  const logout = () => {
    token.value = ''
    userInfo.value = null
    isLoggedIn.value = false
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
    // 退出登录时清空购物车
    const cartStore = useCartStore()
    cartStore.clearCart()
  }


  // 更新用户信息
  const updateUserInfo = (data: Partial<UserInfo>) => {
    if (userInfo.value) {
      userInfo.value = { ...userInfo.value, ...data }
      localStorage.setItem('userInfo', JSON.stringify(userInfo.value))
    }
  }

  return {
    userInfo,
    token,
    login,
    logout,
    isLoggedIn,
    updateUserInfo,
    restoreUserInfo
  }
})